import * as React from 'react';
import { Segment, Grid, Form, Header, Button, Label, Dropdown, Icon } from 'semantic-grab-ui/src';
import formComponent from 'components/decorators/form_component';
import FormInputWithError from 'components/form/FormInputWithError';
import { Campaign } from 'types/ts/campaigns';
import _ from 'lodash';
import './TreatmentForm.scss';
import './WidgetComponent.scss';
import Toastr from 'omega-rtc/utils/toastr-util'
import { getActionsList} from './util';

const sleep = time => {
  return new Promise((resolve) => setTimeout(resolve, time));
}

export interface RandomizerFormProps {
  model: Campaign,
  onModelChange: Function,
  currentNode: string,
  parentNode: string,
  handleCloseModal: Function,
  handleInputChange: Function,
  handleControlBlur: Function,
  isAdd: boolean,
  handleAddNode: Function,
  handleDeleteNode: Function,
  isValid: Function,
  canActivate: boolean,
  parentKeyList: Array<string>,
  listRuleTypes: Object,
  eventType: String,
}

type RandomizerFormState = {
  originalModel: Campaign,
  parentNode: string,
};

@formComponent()
export default class RandomizerForm extends React.Component<
RandomizerFormProps,
  RandomizerFormState
> {
  actionsOptions: any[];
  constructor(props) {
    super(props);
    const { model } = this.props;
    let updatedModel = _.cloneDeep(model);
    const actionDetailedList = getActionsList(props) || [];
    let actionsOptionsList = []
    actionDetailedList.forEach(element => {
      actionsOptionsList.push({
        key: element.type,
        value: element.type,
        text: element.type,
      })
    });
    this.actionsOptions = actionsOptionsList
    this.state = {
      originalModel: this.props.model,
      parentNode: this.props.parentNode,
    };
  }

  componentDidMount() {
    const { isAdd } = this.props
    if (isAdd) {
      this.addBranch();
    }
  }

  cancelRandomizer = () => {
    const { currentNode, isAdd, handleDeleteNode, onModelChange, handleCloseModal, model } = this.props;
    const { originalModel, parentNode } = this.state;
    if (isAdd) {
      // eslint-disable-next-line no-alert
      const confirmValue = confirm(
        'Cancel will delete this inactive node. Are you sure to delete this?',
      );
      if (!confirmValue) return;
      onModelChange(originalModel);
      handleDeleteNode(parentNode, currentNode, -1);
    } else {
      onModelChange(originalModel);
    }
    handleCloseModal();
  };

  saveRandomizer = () => {
    const { currentNode, model, isAdd, handleAddNode, onModelChange } = this.props;
    const branchPercentage = _.get(model.nodes[currentNode], 'data.branchPercentage') || [];

    if((_.get(model.nodes[currentNode], `data.actions`) || []).length === 0) {
      Toastr.error('Add Subactions');
      return;
    } else if(branchPercentage.length === 0) {
      Toastr.error('Add branch');
      return;
    } else if(_.sum(branchPercentage) !== 100) {
      Toastr.error('All Branch sum must be 100%');
      return;
    } else {
      // sum = 100%
      if (this.props.isValid()) {
        if(isAdd) {
          this.addNewRandomizer(model, currentNode, handleAddNode);
        } else {
          const updatedModel = _.cloneDeep(model);
          const children = _.get(updatedModel.nodes[currentNode], 'children') || [];

          let minPercent = 0
          for (let i = 0; i < children.length; i += 1) {
            const maxPercent = minPercent + branchPercentage[i]
            updatedModel.nodes[children[i]]['randomizeRange'] = [minPercent, maxPercent];
            minPercent = maxPercent
          }
          onModelChange(updatedModel);
          this.props.handleCloseModal();
        }

      } else {
        Toastr.error('There are errors in experiment form.');
      }
    }
  };

  addBranch = async () => {
    const { currentNode, model, onModelChange, isAdd } = this.props;
    const actionsList = _.get(model.nodes[currentNode], `data.actions`) || [];
    if(!isAdd && actionsList.length === 0) {
      Toastr.error('Add Subactions');
      return;
    }

    let updatedModel = _.cloneDeep(model);

    // Update the group percentages first
    let branchPercentage =
      _.get(updatedModel.nodes[currentNode], 'data.branchPercentage') || [];

    if (branchPercentage.length === 0) {
      // first branch 100%
      branchPercentage.push(100);
    } else {
      branchPercentage.push(0);
    }

    _.set(
      updatedModel.nodes[currentNode],
      'data.branchPercentage',
      branchPercentage,
    );
    await onModelChange(updatedModel);
  };

  removeBranch =  (index) => {
    if(index === 0) {
      Toastr.error('Cannot delete branch 1');
      return
    }
    const { currentNode, model, onModelChange, handleDeleteNode, isAdd } = this.props;
    const updatedModel = _.cloneDeep(model);

    let branchPercentage = _.get(updatedModel.nodes[currentNode], 'data.branchPercentage') || [];
    let defaultPercentage = branchPercentage[0] + branchPercentage[index]
    branchPercentage.splice(index, 1);

    _.set(updatedModel.nodes[currentNode], `data.branchPercentage.0`,defaultPercentage);

    onModelChange(updatedModel);
    if(!isAdd) {
      sleep(500).then(() => {
        const children = _.get(updatedModel.nodes[currentNode], 'children') || [];
        handleDeleteNode(currentNode, children[index], -1);
      });
    }
  };

  onSubActionAdded = async (event: any, data: any) => {
    const newType = data.value;
    const { currentNode, model, onModelChange } = this.props;
    const updatedModel = _.cloneDeep(model);

    let actionsList = _.get(updatedModel.nodes[currentNode], `data.actions`) || [];
    actionsList.push(newType)
    _.set(updatedModel.nodes[currentNode], 'data.actions', actionsList);
    await onModelChange(updatedModel);
  };

  deleteSubaction = async (index) => {
    const { currentNode, model, onModelChange } = this.props;
    const updatedModel = _.cloneDeep(model);
    let actionsList = _.get(updatedModel.nodes[currentNode], `data.actions`) || [];
    actionsList.splice(index, 1);
    await onModelChange(updatedModel);
  }

  renderActionTag = (action, index, isAdd) => (
    <div>
      <Label
        size="large"
        color="#90ee90"
        style={{
          margin: '2px'
        }}
      >
        {index+1} | {action}
        {isAdd?
          <Icon name='delete' onClick={() => this.deleteSubaction(index)}/>
        :null}
      </Label>
    </div>
  )

  addNewRandomizer = (model: Campaign, currentNode: string, handleAddNode: Function) => {
    const updatedModel = _.cloneDeep(model);
    const branchPercentage = _.get(updatedModel.nodes[currentNode], 'data.branchPercentage') || [];

    // range array
    let randomizeRangeArray = [];
    let minPercent = 0;
    for (let index = 0; index < branchPercentage.length; index++) {
      const maxPercent = minPercent + branchPercentage[index];
      randomizeRangeArray = [ ...randomizeRangeArray, [minPercent, maxPercent]];
      minPercent = maxPercent;
    }

    // action node data
    const actionList = _.get(updatedModel.nodes[this.props.currentNode], 'data.actions', []);
    const newNodeData = [];
    actionList.forEach(element => {
      if (element === 'awardPoint') {
        newNodeData.push({ type: element, meta: { dynamicPoint: 0 } });
      } else {
        newNodeData.push({ type: element, meta: {} });
      }
    });

    const makeNode = range => {
      return new Promise((resolve) => {
        setTimeout(function () {
          handleAddNode(
            'actions',
            currentNode,
            [],
            newNodeData,
            true,
            {
              randomizeRange: [range[0], range[1]],
            });
          resolve(true);
        }, 200);
      });
    };
    Promise.all(randomizeRangeArray.map(d => makeNode(d))).then(() => {
      this.props.handleCloseModal();
    });
  }

  render() {
    const { model, currentNode, isAdd } = this.props;
    const branchPercentage =
      _.get(model.nodes[currentNode], 'data.branchPercentage') || []
    const groupPercentageSum =_.sum(_.get(model.nodes[currentNode], 'data.branchPercentage') || [])
    const actionsList = _.get(model.nodes[currentNode], `data.actions`) || [];
    return (
      <div>
        <div className="model-button">
          <Grid>
            <Grid.Column textAlign="right">
              <Button.Group>
                <Button onClick={this.cancelRandomizer}>Cancel</Button>
                <Button.Or />
                <Button positive onClick={this.saveRandomizer}>
                  Save
                </Button>
              </Button.Group>
            </Grid.Column>
          </Grid>
        </div>
        <div className="treatment-form">

        <Segment className="treatment-form-segment">
          <Grid>
            <Grid.Column width={12}>
              <Header as="h3">Add actions</Header>
            </Grid.Column>
          </Grid>
          <Grid>
            <Grid.Column width={8}>
              <Label
                size="medium"
                color="green"
              >
                Sub-Actions in Order
              </Label>
              <Dropdown
                className="rule-menu"
                text="Add Action"
                simple
                disabled={!isAdd}
                options={this.actionsOptions}
                onChange={this.onSubActionAdded}
              />
            </Grid.Column>
          </Grid>
          <Grid>
            <Grid.Column width={8}>
              {actionsList.map((action, index) => this.renderActionTag(action, index, isAdd))}
            </Grid.Column>
          </Grid>
          </Segment>
          <br />
          <Segment className="treatment-form-segment">
            <Grid>
              <Grid.Column width={12}>
                <Header as="h3">Action Branch percentages</Header>
              </Grid.Column>
            </Grid>
            <Grid>
              <Grid.Column width={12}>
                Total Branch % sum is <b>{groupPercentageSum}</b>. {groupPercentageSum !== 100? "Please make it 100 %": null}
              </Grid.Column>
            </Grid>
            {branchPercentage.map((percentage, index) => (
              <Grid key={`treatment${index}`}>
                <Grid.Column width={6}>
                  Branch {index + 1} Percentage
                </Grid.Column>
                <Grid.Column width={6}>
                  <FormInputWithError
                    name={`nodes.${currentNode}.data.branchPercentage.${index}`}
                    {...this.props}
                  >
                    <Form.Input
                      type="number"
                      required
                      step="1"
                      pattern="\d+"
                      disabled={index===0}
                      value={_.get(model.nodes[currentNode], `data.branchPercentage.${index}`)}
                      onChange={(event: any, data: any) => {
                        const roundedValue = parseInt(data.value)
                        const newDefaultVal = branchPercentage[0] + branchPercentage[index] - roundedValue
                        if (newDefaultVal > 0) {
                          // cannnot set default to eq,lt 0
                          _.set(model.nodes[currentNode], `data.branchPercentage.0`,newDefaultVal);
                          data.value = `${roundedValue}`
                          this.props.handleInputChange(event, data)
                        }
                      }}
                      onBlur={this.props.handleControlBlur}
                      min={0}
                    />
                  </FormInputWithError>
                </Grid.Column>
                {index > 0?
                  <Grid.Column width={2}>
                    <Button disabled={!isAdd} onClick={() => this.removeBranch(index)}>
                      Delete
                    </Button>
                  </Grid.Column>
                :null}
              </Grid>
            ))}
            {isAdd?
              <Button positive onClick={() => this.addBranch()}>
                Add new branch
              </Button>
            :null}
          </Segment>
        </div>
      </div>
    );
  }
}
